import { useQuery } from "react-query";
import { getVoidedInvoiceCount } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

const useGetVoidedInvoiceCount = () => {
  return useQuery("GetVoidedInvoiceCount", getVoidedInvoiceCount, {
    refetchOnWindowFocus: false,
  });
};

export default useGetVoidedInvoiceCount;
